import React from 'react'

import Accordion from 'components/Accordion'
import Avatars from 'components/Avatars'
import Grid from 'components/Grid'
import Review from 'components/Review'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'

import classes from './SnippetsAccordion.module.scss'

const SnippetsAccordion = ({ snippets, defaultExpanded, columns = 1 }) => {
  const { sendEvent } = useEventContext()

  // eslint-disable-next-line no-unused-vars
  const avatars = snippets.map(snippet => snippet.avatar).sort((a, b) => (a === null ? -1 : 1))

  const accordionOnExpandClick = (_, { isExpanded }) => {
    detachTask(sendEvent, {
      engagementDestination: (isExpanded ? 'open' : 'close') + '_snippets-accordion',
      engagementDetails: isExpanded
        ? 'text-link_see-individual-user-reviews'
        : 'text-link_hide-individual-user-reviews',
      name: 'engagement_product_click',
    })
  }

  return (
    <Accordion
      className={classes.root}
      defaultExpanded={defaultExpanded}
      onExpandClick={accordionOnExpandClick}
      summaryClassname={classes.accordionSummary}
      summary={
        <div className={classes.accordionContainer}>
          <Avatars className={classes.avatars} imagesUrl={avatars} imageSize={24} />
          <Typography variant="body-sm" className={classes.accordionTitle}>
            See related user reviews
          </Typography>
        </div>
      }
      details={
        <Grid className={classes.snippetsContainer} container spacing={2}>
          {snippets.map(snippet => (
            <Grid item xs={12} sm={columns > 1 ? 6 : 12} key={snippet.id} className={classes.snippetContainer}>
              <Review.Snippet size="large" type={snippet.type} snippet={snippet} className={classes.snippet} />
            </Grid>
          ))}
        </Grid>
      }
    />
  )
}

export default SnippetsAccordion
